import axios from "axios";
import { headers, jwt } from "./constants";
import * as yup from "yup";

export interface IUserModelledYear {
  id?: string;
  noOfYears?: number;
  longTermInterestRate?: number;
  commercialReturn?: number;
  ownerId?: string;
}

export let create = async (userModelledYear: IUserModelledYear) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/userModelledYear/create",
      { data: userModelledYear },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};

export let get = async (ownerId: string) => {
  let hasError = false;
  let response: any = await axios
    .get(process.env.REACT_APP_API_URL + "/userModelledYear/get/", {
      headers: headers,
      params: { ownerId: ownerId },
    })
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { data: response.data, hasError };
};

export let update = async (userModelledYear: IUserModelledYear) => {
  let hasError = false;
  await axios
    .post(
      process.env.REACT_APP_API_URL + "/userModelledYear/update",
      { data: userModelledYear },
      {
        headers: headers,
      }
    )
    .catch(function (error) {
      if (error.response) {
        hasError = true;
      }
    });
  return { hasError };
};
